import { useState, useEffect } from "react";

const getDeviceType = () => {
  const width = window.innerWidth;
  return {
    isMobile: width <= 743,
    isTablet: width > 743 && width <= 1023,
    isDesktop: width > 1023,
  };
};

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState(getDeviceType());

  useEffect(() => {
    const handleResize = () => setDeviceType(getDeviceType());
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return deviceType;
};

export default useDeviceType;
